var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0002 3.14285C6.66092 3.14285 3.14307 6.66071 3.14307 11C3.14307 15.3393 6.66092 18.8571 11.0002 18.8571C15.3395 18.8571 18.8574 15.3393 18.8574 11C18.8574 6.66071 15.3395 3.14285 11.0002 3.14285ZM14.4059 9.67143C14.4686 9.59974 14.5164 9.51624 14.5463 9.42583C14.5763 9.33542 14.5879 9.23993 14.5804 9.14499C14.5729 9.05004 14.5465 8.95754 14.5028 8.87294C14.459 8.78835 14.3988 8.71336 14.3256 8.65238C14.2524 8.59141 14.1678 8.54568 14.0767 8.5179C13.9856 8.49011 13.8899 8.48083 13.7951 8.49059C13.7004 8.50035 13.6086 8.52896 13.525 8.57473C13.4415 8.62051 13.368 8.68253 13.3088 8.75714L10.2374 12.4421L8.64807 10.8521C8.51335 10.722 8.33292 10.65 8.14564 10.6517C7.95835 10.6533 7.7792 10.7284 7.64677 10.8608C7.51433 10.9933 7.43921 11.1724 7.43758 11.3597C7.43596 11.547 7.50795 11.7274 7.63807 11.8621L9.78092 14.005C9.85111 14.0751 9.93513 14.1299 10.0276 14.1658C10.1202 14.2016 10.2191 14.2178 10.3183 14.2133C10.4174 14.2088 10.5145 14.1837 10.6034 14.1396C10.6922 14.0955 10.771 14.0334 10.8345 13.9571L14.4059 9.67143Z",
    fill: "#1A9D86"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.e11122a2.svg";
export { ForwardRef as ReactComponent };